<template>
  <div
    ref="kt_modal_kits_consultar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_kits_consultar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-body p-0">
          <div class="card">
            <div class="card-header">
              <div class="card-title d-flex align-items-center">
                <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                  <inline-svg src="media/icons/duotune/art/art002.svg" />
                </span>
                <h3 class="fw-bold m-0 text-gray-800">Kits</h3>
              </div>
              <div
                class="btn btn-icon btn-sm btn-active-light-primary mt-6"
                data-bs-dismiss="modal"
                @click="this.$emit('exibirModalKits', false)"
              >
                <span class="svg-icon svg-icon-1 svg-icon lh-0">
                  <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                </span>
              </div>
            </div>
            <div class="card-body p-0">
              <div
                v-if="this.errosValidacaoGeral.length"
                class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
              >
                <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                  <inline-svg src="media/icons/duotune/general/gen044.svg" />
                </span>
                <div class="d-flex flex-stack flex-grow-1">
                  <div class="fw-bold">
                    <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                    <div class="fs-6 text-gray-600">
                      <ul>
                        <li
                          v-for="value in this.errosValidacaoGeral"
                          :key="value"
                        >
                          {{ value }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-header border-0 pt-5">
                <div class="card-title align-items-end mb-3">
                  <div class="d-flex align-items-center position-relative my-1">
                    <span class="svg-icon svg-icon-1 position-absolute ms-6">
                      <inline-svg
                        src="media/icons/duotune/general/gen004.svg"
                      />
                    </span>
                    <input
                      type="text"
                      id="txtPesquisarKits"
                      v-model="tableData.search"
                      @input="onSearch($event.target.value)"
                      class="form-control form-control-solid w-250px ps-15"
                      placeholder="Pesquisar Kit"
                    />
                  </div>
                </div>
                <div class="card-toolbar">
                  <div
                    v-if="checkedKits.length === 0"
                    class="d-flex justify-content-end align-items-end mb-3"
                    data-kt-customer-table-toolbar="base"
                  >
                    <div v-if="showSelection" class="col-auto fv-row me-4">
                      <label class="form-label">Qtd à importar</label>
                      <div class="col">
                        <el-input-number
                          :id="`qtdImportar`"
                          v-model="qtdImportar"
                          class="w-150px"
                          :min="1"
                          :max="undefined"
                          size="large"
                          controls-position="right"
                          @focus="onFocus($event.target.id)"
                        />
                        <div
                          v-if="getErrorByID(`qtdImportar`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`qtdImportar`) }}
                        </div>
                      </div>
                    </div>
                    <button
                      v-if="this.adicionar"
                      @click="adicionarKit()"
                      class="btn btn-sm btn-primary"
                    >
                      <span class="svg-icon svg-icon-1">
                        <inline-svg
                          src="media/icons/duotune/general/gen041.svg" /></span
                      >Adicionar
                    </button>
                  </div>
                  <div
                    v-else
                    class="d-flex justify-content-end align-items-center"
                    data-kt-customer-table-toolbar="selected"
                  >
                    <div class="fw-bolder me-5">
                      <span class="me-2">{{ checkedKits.length }}</span
                      >Selecionado(s)
                    </div>
                    <button
                      v-if="this.excluir"
                      type="button"
                      class="btn btn-sm btn-danger"
                      @click="deleteSelecionados()"
                    >
                      Excluír Selecionado(s)
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <Datatable
                  ref="table"
                  :table-header="tableHeader"
                  :table-data="tableData"
                  :table-pagination="tablePagination"
                  :page-sizes="pageSizes"
                  :enable-items-per-page-dropdown="true"
                  :hide-on-single-page="false"
                  empty-table-text="Nenhum kit encontrado"
                  @checked-rows="checkedKits = $event"
                >
                  <template v-slot:cell-checkbox="{ row: kit }">
                    <div
                      class="form-check form-check-sm form-check-custom form-check-solid"
                    >
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="kit.id"
                        v-model="checkedKits"
                      />
                    </div>
                  </template>
                  <template v-slot:cell-id="{ row: kit }">
                    {{ kit.id }}
                  </template>
                  <template v-slot:cell-nome="{ row: kit }">
                    {{ kit.nome }}
                  </template>
                  <template v-slot:cell-ProdutoCodigo="{ row: kit }">
                    {{ kit.Produto ? kit.Produto.codigo : "" }}
                  </template>
                  <template v-slot:cell-total="{ row: kit }">
                    {{ this.$utils.formatarNumero(retornaTotalProdKit(kit)) }}
                  </template>
                  <template v-slot:cell-acoes="{ row: kit }">
                    <div class="min-w-300px">
                      <button
                        v-if="this.showSelection"
                        type="button"
                        class="btn btn-sm btn-light btn-light-primary my-2 me-2"
                        @click="this.selecionarKit(kit)"
                      >
                        Selecionar
                      </button>
                      <button
                        v-if="this.consultarProdKit"
                        type="button"
                        class="btn btn-sm btn-light btn-light-success me-2 my-2"
                        @click="consultarProdutosKit(kit.id)"
                      >
                        Produtos
                      </button>
                      <button
                        class="btn btn-sm btn-light btn-active-light-primary"
                        data-kt-menu-trigger="click"
                        data-kt-menu-placement="bottom-end"
                        data-kt-menu-flip="top-end"
                      >
                        Ações
                        <span class="svg-icon svg-icon-5 m-0">
                          <inline-svg
                            src="media/icons/duotune/arrows/arr072.svg"
                          />
                        </span>
                      </button>
                      <div
                        v-if="this.editar || this.excluir"
                        class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                        data-kt-menu="true"
                      >
                        <div v-if="this.editar" class="menu-item px-3">
                          <a @click="editarKit(kit)" class="menu-link px-3"
                            >Editar</a
                          >
                        </div>
                        <div v-if="this.excluir" class="menu-item px-3">
                          <a
                            @click="removerRegistro(kit.id)"
                            class="menu-link px-3"
                            >Excluír</a
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                </Datatable>
                <ProdutosKitModal
                  ref="ConsultaProdutosKit"
                  v-if="exibirProdutosKit"
                  :modal="!showSelection"
                  :idKit="this.idKit"
                  @exibirModalProdutosKit="modalProdutosKit"
                  @confirmarProdutoKit="this.$refs.table.load()"
                ></ProdutosKitModal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="this.exibirEditarKit"
    id="kt_modal_kit_editar"
    ref="kt_modal_kit_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.kit.id === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Kit
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Kit
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.modalEditarKit(false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row">
            <div class="col-md-3 fv-row mb-4">
              <label class="form-label">Código</label>
              <input
                id="txtCodigo"
                type="text"
                class="form-control mb-2"
                v-model="kit.id"
                disabled
              />
            </div>
            <div class="col-md-9 fv-row mb-4">
              <label class="required form-label">Nome do Produto</label>
              <div class="input-group mb-2">
                <input
                  id="txtNomeProduto"
                  type="text"
                  class="form-control"
                  placeholder="Nome do Produto"
                  maxlength="75"
                  :value="
                    (this.kit.nome = this.kit.nome
                      ? this.kit.nome.toUpperCase()
                      : '')
                  "
                  @input="this.kit.nome = $event.target.value.toUpperCase()"
                  @keydown.stop.prevent.enter="nextFocus(`btnConfirmarKit`)"
                />
                <span
                  class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                  @click="limparProduto()"
                >
                  <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                </span>
                <button
                  type="button"
                  class="input-group-text"
                  @click="modalProdutos(true)"
                >
                  <span class="svg-icon svg-icon-2">
                    <inline-svg src="media/icons/duotune/general/gen004.svg" />
                  </span>
                </button>
              </div>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["nome"] }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            data-bs-dismiss="modal"
            @click="this.modalEditarKit(false)"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            id="btnConfirmarKit"
            @click="confirmarKit()"
            v-bind:data-kt-indicator="this.loadingKit ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loadingKit">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <component
    :is="modalComponent"
    v-if="exibirProdutos"
    @exibirModalProdutos="modalProdutos"
    @selecionarProduto="selecionarProduto"
  ></component>
</template>

<script>
import { markRaw } from "vue";
import _ from "lodash";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import ProdutosKitModal from "../produtos/ProdutosKitModal.vue";
//import ProdutosModal from "@/views/produtos/ProdutosModal.vue";
import { mapState } from "vuex";
import { defineComponent } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
import {
  hideModal,
  hideModalId,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";

export default defineComponent({
  emits: ["exibirModalKits", "selecionarKit"],
  components: {
    Datatable,
    ProdutosKitModal,
    //ProdutosModal,
  },
  props: {
    showSelection: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async selecionarKit(kit) {
      this.errosValidacao = {};
      if ((await this.validar()) === true) {
        this.$emit("selecionarKit", kit, this.qtdImportar);
        this.$emit("exibirModalKits", false);
        hideModalId("kt_modal_kits_consultar");
      } else {
        await this.$swal.showInvalidAlert("Verifique os avisos!");
      }
    },
    async validar() {
      let result = true;

      if (!this.$utils.isInteger(this.qtdImportar)) {
        this.errosValidacao[`qtdImportar`] =
          "A quantidade à importar é inválida";
        result = false;
      }

      return result;
    },
    getErrorByID(id) {
      return this.errosValidacao[id] &&
        this.errosValidacao[id] !== undefined &&
        this.errosValidacao[id] !== ""
        ? this.errosValidacao[id]
        : null;
    },
    onFocus(id) {
      document.getElementById(id).select();
    },
    retornaTotalProdKit(kit) {
      if (kit.ProdKit != null) {
        return _.sumBy(kit.ProdKit, "total");
      } else {
        return 0;
      }
    },
    limparProduto() {
      this.kit.nome = "";
      this.kit.id_produto = null;
    },
    modalProdutos(exibir) {
      this.exibirProdutos = exibir;
      import("@/views/produtos/ProdutosModal.vue").then((module) => {
        this.modalComponent = markRaw(module.default);
      });
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal(
            "kt_modal_produtos_consultar",
            /*open*/ () => {
              this.$utils.requestFocus("txtPesquisarProdutos");
            },
            /*close*/ () => {
              this.modalProdutos(false);
            }
          );
        }, 100);
      }
    },
    selecionarProduto(produto) {
      this.kit.nome = produto.nome;
      this.kit.id_produto = produto.id;
      setTimeout(() => {
        this.nextFocus("txtNomeProduto");
      }, 500);
    },
    modalProdutosKit(exibir) {
      this.exibirProdutosKit = exibir;
      if (exibir === true) {
        if (this.showSelection) {
          this.$refs.ConsultaProdutosKit.loadData();
        } else {
          getOrCreateInstanceModal(
            "kt_modal_produtos_kit_consultar",
            /*open*/ () => {
              this.$utils.requestFocus("txtPesquisarProdKits");
            },
            /*close*/ () => {
              this.modalProdutosKit(false);
            }
          );
        }
      } else {
        this.$refs.table.load();
        this.$utils.requestFocus("txtPesquisarKits");
      }
    },
    consultarProdutosKit(idKit) {
      this.idKit = idKit;
      this.modalProdutosKit(true);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(nome, '" + pesquisa + "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    async deleteSelecionados() {
      await this.$swal.showQuestionAlert(
        "Deseja remover os registros selecionados?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.excluiuCadastro = true;
            this.$refs.table.setLoading(true);
            for (var i = 0; i < this.checkedKits.length; i++) {
              await this.excluirKit(this.checkedKits[i]);
            }
            if (this.excluiuCadastro === true) {
              toast.success("Kits excluídos com sucesso!", {
                timeout: 3000,
              });
            }
            this.$refs.table.load();
          }
        }
      );
    },
    async removerRegistro(id) {
      await this.$swal.showQuestionAlert(
        "Deseja remover o registro?",
        async (alert) => {
          if (alert.isConfirmed) {
            this.errosValidacaoGeral = [];
            this.excluiuCadastro = true;
            this.$refs.table.setLoading(true);
            await this.excluirKit(id);
            if (this.excluiuCadastro === true) {
              toast.success("Kit excluído com sucesso!", {
                timeout: 3000,
              });
            }
            this.$refs.table.load();
          }
        }
      );
    },
    async excluirKit(id) {
      try {
        await this.$store.dispatch("kit/deleteKit", id);
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },
    modalEditarKit(exibir) {
      this.exibirEditarKit = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_kit_editar",
          /*open*/ () => {
            this.errosValidacao = [];
            this.$utils.requestFocus("txtNomeProduto");
          },
          /*close*/ () => {
            this.modalEditarKit(false);
          }
        );
      }
    },
    adicionarKit() {
      this.kit = {
        id: 0,
        nome: "",
        id_produto: null,
      };
      this.modalEditarKit(true);
    },
    editarKit(kit) {
      this.kit = kit;
      this.modalEditarKit(true);
    },
    async confirmarKit() {
      this.errosValidacao = [];
      this.loadingKit = true;
      if (this.kit.id === 0) {
        try {
          var ret = await this.$store.dispatch("kit/postKit", this.kit);
          if (ret.Success === true) {
            toast.success("Kit cadastrado com sucesso!", {
              timeout: 3000,
            });
            hideModalId("kt_modal_kit_editar");
            this.modalEditarKit(false);
            this.$refs.table.load();
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      } else {
        try {
          var retPut = await this.$store.dispatch("kit/putKit", this.kit);
          if (retPut.Success === true) {
            toast.success("Kit alterado com sucesso!", {
              timeout: 3000,
            });
            hideModalId("kt_modal_kit_editar");
            this.modalEditarKit(false);
            this.$refs.table.load();
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      }
      this.loadingKit = false;
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.Kit.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.Kit.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.Kit.Excluir") {
            this.excluir = true;
          }

          if (element.regra === "Permitir.ProdKit.Consultar") {
            this.consultarProdKit = true;
          }
        });
      }
    },
  },
  async mounted() {
    this.verificarRestricoes();
    this.$utils.requestFocus("txtPesquisarKits");
  },
  data() {
    return {
      consultarProdKit: false,
      timeOut: null,
      modalComponent: null,
      qtdImportar: 1,
      idKit: 0,
      exibirEditarKit: false,
      exibirProdutos: false,
      exibirProdutosKit: false,
      loadingKit: false,
      kit: {
        id: 0,
        nome: "",
        id_produto: null,
      },
      adicionar: false,
      editar: false,
      excluir: false,
      checkedKits: [],
      errosValidacaoGeral: [],
      errosValidacao: {},
      excluiuCadastro: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "Nome do kit",
          key: "nome",
          sortable: true,
        },
        {
          name: "Produto",
          key: "ProdutoCodigo",
          sortingField: "Produto/codigo",
          sortable: true,
        },
        {
          name: "Total",
          key: "total",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "kit/getKitOData",
        selectOData:
          "?$select=id,nome,id_produto&$expand=ProdKit($select=total),Produto($select=codigo)",
        filterOData: "",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
});
</script>

<style></style>
